export default __webpack_public_path__ + "assets/images/25db3068b9743bd07efbed12ce673eaa.png";